import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import TenableCloudSecurityConfigListing from "./TenableCloudSecurityConfigListing";
import TenableCloudSecurityCredentialsForm from "./TenableCloudSecurityCredentialsForm";

export default function TenableCloudSecurityPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={TenableCloudSecurityCredentialsForm}
      PullConfigListingView={TenableCloudSecurityConfigListing}
    />
  );
}
